import request from './request.js';
export const loginByUsername = (tenantId, deptId, roleId, username, password, type, key, code) => request({
    url: '/api/blade-auth/oauth/token',
    method: 'post',
    headers: {
        'Tenant-Id': tenantId,
        'Dept-Id': '',
        'Role-Id': '',
        'Captcha-Key': key,
        'Captcha-Code': code,
    },
    params: {
        tenantId,
        username,
        password,
        grant_type: 'password',
        scope: "all",
        type
    }
});

export const getRoutes = () => request({
    url: '/api/blade-system/menu/routes?remark=1',
    method: 'get'
});

// 首页统计
export const homeInfos = (params) => request({
    url: '/api/blade-admin/statistics/h5/indexInfoStatistics',
    method: 'get',
    params
});
export const netNameStatisticsData = (params) => request({
    url: '/api/blade-admin/statistics/h5/netNameStatisticsData',
    method: 'get',
    params
});

export const offlineInfos = (params) => request({
    url: '/api/blade-admin/statistics/h5/offlineInfos',
    method: 'get',
    params
});

export const getAreaList = (params) => request({
    url: '/api/blade-system/region/lazy-tree',
    method: 'get',
    params
});

export const outStockInfos = (data) => request({
    url: '/api/blade-admin/statistics/h5/outStockInfos',
    method: 'post',
    data
});

export const getTenantList = () => request({
    url: '/api/blade-weixin/user/tenantList',
    method: 'get'
});

